












































import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import {
    SanitizedHtml,
    SdsBrandImage,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';
import KycStatusAlert from './KycStatusAlert.vue';

type ListItem = {
    icon: string;
    text: string;
};

export default defineComponent({
    name: 'VerificationPrompt',
    emits: [
        'startIdentityVerification',
    ],
    props: {
        status: {
            type: String as PropType<'initial' | 'failed'>,
            required: false,
            default: 'initial',
        },
        infoItems: {
            type: Array as PropType<ListItem[]>,
            required: false,
            default: () => (
                [
                    {
                        icon: 'human-user-id',
                        text: 'pam.kyc.introNew.info.idCard',
                    },
                    {
                        icon: 'human-face-id',
                        text: 'pam.kyc.introNew.info.faceRecognition',
                    },
                    {
                        icon: 'data-privacy',
                        text: 'pam.kyc.introNew.info.security',
                    },
                ]
            ),
        },
    },
    components: {
        SdsIcon,
        SdsBrandImage,
        SanitizedHtml,
        KycStatusAlert,
    },
});
